import { Injectable } from '@angular/core';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { Platform } from '@ionic/angular';
import { LogService } from './log.service';

@Injectable({
  providedIn: 'root'
})
export class SplashscreenService {
  public readonly AVERAGE_INITIALIZATION_TIME = 1600;
  private readonly FALLBACK_TIME = 9000;

  constructor(
    private splashScreen: SplashScreen,
    private platform: Platform,
    private log: LogService
  ) {}

  hideFromStartPages() {
    // This Method implementation could be improved with Angular Router
    this.log.d(this, `Setting timeout for hiding splash screen`);
    setTimeout(() => this.hide(), this.AVERAGE_INITIALIZATION_TIME);
  }

  hideFromAppComponent() {
    setTimeout(() => this.hide(), this.FALLBACK_TIME);
  }

  private hide() {
    if (!this.platform.is('cordova')) { return; }
    this.log.d(this, `Hiding splash screen`);
    this.splashScreen.hide();
  }
}
